module.exports = __webpack_public_path__ + "660bebdd09e47fb9328d75fb3ff8e7f2.png";